import { render, staticRenderFns } from "./ModalTheme.vue?vue&type=template&id=10fabd5a"
import script from "./ModalTheme.vue?vue&type=script&lang=js"
export * from "./ModalTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports